import { useTranslation } from 'react-i18next';

import FieldError from '@/components/form/FieldError';
import GooglePlacesInput from '@/components/form/shared/GooglePlacesInput';

import type { SizeType } from 'antd/es/config-provider/SizeContext';

interface AddressProps {
  address: string;
  setAddress: (data: string) => void;
  validating?: boolean;
  size?: SizeType;
}

export const AddressFieldInput = ({
  address,
  validating,
  setAddress,
  size,
}: AddressProps) => {
  const [t] = useTranslation();

  return (
    <>
      <GooglePlacesInput
        mode="address"
        value={address}
        onChange={setAddress}
        size={size}
      />
      {validating && !address && <FieldError>{t('REQUIRED_FIELD')}</FieldError>}
      {validating && address && address.length > 255 && (
        <FieldError>{t('MAX_LENGTH_RULE', { number: 255 })}</FieldError>
      )}
    </>
  );
};
